import { HttpParams } from "@angular/common/http"
import { Component, OnInit } from "@angular/core"
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms"
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete"
import { MatRadioChange } from "@angular/material/radio"
import { ToastrService } from "ngx-toastr"
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component"
import { WalletService } from "../wallet.service"
import { Params, Router } from '@angular/router';
import createNumberMask from 'text-mask-addons/dist/createNumberMask'


@Component({
  selector: "app-add-funds",
  templateUrl: "./add-funds.component.html",
  styleUrls: ["./add-funds.component.scss"],
})
export class AddFundsComponent extends FeaturesBaseComponent implements OnInit {
  retailerList: any[] = []
  accountNumber = new FormControl()
  addMoneyForm: FormGroup
  filteredOptions: any[] = []
  filteredDataretailerName: any[] = []
  filteredSalesrepOptions: any[] = []
  retailerAccountSummary: any
  // filteredOptions: Observable<any[]>;
  retailerChecked: boolean = false
  autoReloadAlertControl = new FormControl()
  balanceAlertControl =  new FormControl()
  showAutoReload: boolean = false
  showbalanceAlert: boolean = false
  adminFundsRadioControl = new FormControl('retailer')
  creditAvailable: any;
  showLowbalanceAlert: boolean = false;
  salesRepList: any
  thresholdAmnt: any
  showRecieveAlert: boolean
  emailRegx = /^(([^<>+()\[\]\\.,;:\s@"-#$%&=]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;
  phoneRegx = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
  phone: (string | RegExp)[]
  numberMask = createNumberMask({
    prefix: '$ ',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol :',',
    allowDecimal :true,
  })

  constructor(private router: Router, private fb: FormBuilder, private walletService: WalletService, private toastService: ToastrService) {
    super()
    //
    this.phone = ['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    this.initiateForm()



    this.addMoneyForm.get("accountNumber").valueChanges.subscribe((res) => {
      // this.addRemoveFundForm.get("retailerName").setValue('');

      this.filteredOptions = res
        ? this._filterAccountNumber(res)
        : this.retailerList.slice()
    })

    this.addMoneyForm.get("retailerName").valueChanges.subscribe((res) => {
      let retailerName: string;
      if (res?.retailerName) {
        retailerName = res.retailerName
      }
      else {
        retailerName = res
      }
      this.filteredOptions = this.retailerList;
      // this.addRemoveFundForm.get("accountNumber").setValue('');
      this.retailerChecked = true
      this.adminFundsRadioControl.setValue('retailer');

      this.filteredOptions = res
        ? this._filterRetailerName(retailerName)
        : this.retailerList.slice()
    })

    this.addMoneyForm.get("salesRepName").valueChanges.subscribe((res) => {
      
      let salesRepName: string;
      if (res?.userDetails) {
        salesRepName = res.userDetails.displayName
      }
      else {
        salesRepName = res
      }
      this.filteredSalesrepOptions = this.salesRepList;
      this.adminFundsRadioControl.setValue('salesRep');
      this.filteredSalesrepOptions = res
        ? this._filterSalesRepName(salesRepName)
        : this.salesRepList.slice();
    });

  }

  ngOnInit(): void {
    this.getAllRetailersList();

    this.getSalesRepsList();

    this.addMoneyForm.controls['email'].valueChanges.subscribe(
      res => {
        if (this.addMoneyForm.get('email').value?.length > 0) {
          this.addMoneyForm.get('email').setValidators([Validators.required])
          this.addMoneyForm.get('mobileNumber').setValue('')
          this.addMoneyForm.controls['mobileNumber'].clearValidators()
          this.addMoneyForm.updateValueAndValidity()
        }
      }
    )
      let _dd =0;
    this.addMoneyForm.controls['mobileNumber'].valueChanges.subscribe(
      res => {
        if (this.addMoneyForm.get('mobileNumber').value?.length > 0){
            this.addMoneyForm.get('mobileNumber').setValidators([Validators.required])
          this.addMoneyForm.get('email').setValue('')
          this.addMoneyForm.controls['email'].clearValidators()
          this.addMoneyForm.updateValueAndValidity()
        }
      }
    )
   

  }

  getSalesRepsList() {
    this.walletService.getSlaesRepList().subscribe((res) => {

      if (res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_101") || res.responseStatus == 'Success') {
       
        this.salesRepList = res.data;
        this.filteredSalesrepOptions = this.salesRepList;
      }
    });
  }

  getAllRetailersList() {
    this.walletService.getSlaesRepRetailerList().subscribe((res) => {

      if (res.httpcode == 200) {
       
        this.retailerList = res.data;
        this.filteredOptions = this.retailerList;
      }
    });
  }


  selectedAccountType(e: MatRadioChange) {
    let selectedAccountType: any = e.value;
    if (e.value == 'salesRep') {
      this.addMoneyForm.get("retailerName").setValue('');
      this.addMoneyForm.get("accountNumber").setValue('');

      this.addMoneyForm.reset();
    } else
      if (e.value == 'retailer') {
        this.addMoneyForm.get("salesRepName").setValue('');
        this.addMoneyForm.reset();
      }
    this.adminFundsRadioControl.setValue(selectedAccountType);
  }

  getSelected(event) {
    
  }

  retailerDetailsList: any = {}
  retailerDetails: any = {}
  selectedRetailerName(data) {
    
    this.walletService
      .getallRetailerDetailsById(data.option.value['retailerDetails'].retailerId)
      .subscribe((res) => {

        if (res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_101") || res.responseStatus == 'Success') {
          this.retailerDetailsList = res.data;
          
          this.retailerDetails = res.data.retailerDetails;
          this.retailerAccountSummary = res.data.retailerAccountSummary;
          this.addMoneyForm.patchValue({
            retailerType: this.retailerDetails.retailerType,
            otpMobileNumber: this.retailerDetails.otpMobileNumber,
            businessName: this.retailerDetails.businessName,
            dbaName: this.retailerDetails.dbaName,
            address1: this.retailerDetails.address1,
            currentAmount: this.retailerAccountSummary.currentAmount,

            autoReloadAmount: this.retailerDetailsList.retailerAccounts.autoReloadThresholdAmount,
            fallAmount: this.retailerDetailsList.retailerAccounts.thresholdMinAmt,
            
          });
          this.autoReloadAlertControl.setValue((this.retailerDetailsList.retailerAccounts.autoReloadThresholdStatus.toLowerCase() === 'true')),
          this.balanceAlertControl.setValue((this.retailerDetailsList.retailerAccounts.lowBalanceThresholdAlertStatus.toLowerCase() === 'true'))
          this.checkReceiveLowBalAlert(this.balanceAlertControl.value)
          this.thresholdAmnt = this.retailerDetailsList.retailerAccounts.thresholdMinAmt;
          
          this.showAutoReload = (this.retailerDetailsList.retailerAccounts.autoReloadThresholdStatus.toLowerCase() === 'true');
          this.showbalanceAlert = (this.retailerDetailsList.retailerAccounts.lowBalanceThresholdAlertStatus.toLowerCase() === 'true');
          this.creditAvailable = this.retailerDetailsList.retailerAccountSummary.currentAmount;
          
          
          
          this.showLowbalanceAlert = false;
          if (this.creditAvailable < this.thresholdAmnt) {
            this.showLowbalanceAlert = true;
          }
          this.addMoneyForm.get('salesRepName').setValue('');
          this.adminFundsRadioControl.setValue('retailer')

        }
      });
  }


  selectedSalesRepDetails(data: MatAutocompleteSelectedEvent) {
    
    this.walletService
      .getSalesRepDetailsById(data.option.value?.userId)
      .subscribe((res) => {

        if (res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_101") || res.responseStatus == 'Success') {
          this.retailerDetailsList = res.data;
          
          this.retailerDetails = res.data.userDetails;
          this.retailerAccountSummary = res.data.retailerAccountSummary;
          this.addMoneyForm.patchValue({
            retailerType: this.retailerDetails.retailerType,
            otpMobileNumber: this.retailerDetails.phoneNumber,
            businessName: this.retailerDetails.displayName, 
            dbaName: this.retailerDetails.displayName,
            address1: this.retailerDetails.address1,
            currentAmount: res.data.salesRepWallet.balance,
            autoReloadAmount: this.retailerDetailsList.salesRepWallet.autoReloadCreditLimit,
            fallAmount: this.retailerDetailsList.salesRepWallet.minimumThresholdAmount,
            
          });
          this.autoReloadAlertControl.setValue( (this.retailerDetailsList.salesRepWallet.autoReloadThresholdStatus.toLowerCase() === 'true')),
          this.balanceAlertControl.setValue((this.retailerDetailsList.salesRepWallet.lowBalanceThresholdAlertStatus?.toLowerCase() === 'true'))
          
          this.showAutoReload = (this.retailerDetailsList.salesRepWallet.autoReloadThresholdStatus?.toLowerCase() === 'true');
          this.showbalanceAlert = (this.retailerDetailsList.salesRepWallet.lowBalanceThresholdAlertStatus?.toLowerCase() === 'true');
          this.creditAvailable = res.data.salesRepWallet.balance;

          this.thresholdAmnt = this.retailerDetailsList.salesRepWallet.minimumThresholdAmount;
          
          
          
          this.showLowbalanceAlert = false;

          if (this.creditAvailable < this.thresholdAmnt) {
            this.showLowbalanceAlert = true;
          }



          this.addMoneyForm.get('retailerName').setValue('');
          this.adminFundsRadioControl.setValue('salesRep')
        }
      })
  }
  getOptionretailerName(option) {
    if (option != null && option != undefined) {
      return option.retailerName
    }
    return
  }

  getOptionSalesrepName(option) {
    if (option != null && option != undefined) {
      return option.name
    }
    return
  }

  initiateForm = () => {
    this.addMoneyForm = this.fb.group({
      fallAmount: ["", Validators.required],
      autoReloadAmount: [""],
      mobileNumber: [""],
      email: [""],
      salesRepName: [""],
      autoReloadAlert: [this.autoReloadAlertControl],
      balanceAlert: [this.balanceAlertControl],
      retailerName: [""],
      retailerType: [""],
      otpMobileNumber: [""],
      businessName: [""],
      dbaName: [""],
      address1: [""],
      currentAmount: [""],
      accountNumber: [""],
    })
  }
  get f() {
    return this.addMoneyForm.controls
  }
  checkAutoReoload(e) {
    if (e) {
      this.showAutoReload = true
    } else if (!e) {
      this.showAutoReload = false
    }
  }

  checkReceiveLowBalAlert(e) {

    this.showRecieveAlert = this.balanceAlertControl.value;
    if (e) {
      this.showbalanceAlert = true
      this.addMoneyForm.controls['mobileNumber'].setValidators([Validators.required])
    } else if (!e) {
      this.addMoneyForm.controls['mobileNumber'].clearValidators()
      this.showbalanceAlert = false
    } 
    this.addMoneyForm.controls['mobileNumber'].updateValueAndValidity();
   }

  keyUpEvent(event) {
    let totalAmount =
      Number(event.target.value) +
      Number(this.retailerAccountSummary.currentAmount)

    this.addMoneyForm.patchValue({
      newBalance: totalAmount,
      // currentAmount: this.retailerAccountSummary.currentAmount,
    })
    // 
  }



  getOptionText(option) {
    if (option != null && option != undefined) {
      return option.accountNumber
    }
    return
  }

  selectedclient(event) {
    
  }

  private _filterAccountNumber(value: string): any[] {
    const filterValue = value.toLowerCase()
    return this.retailerList.filter(
      (state) => state.accountNumber.toLowerCase().indexOf(filterValue) === 0
    )
  }

  private _filterRetailerName(value: string): any[] {
    
    const filterValue = value.toLowerCase()
    return this.retailerList.filter(
      (state) => state.retailerName.toLowerCase().indexOf(filterValue) === 0
    )
  }
  private _filterSalesRepName(value: string) {
   
    const filterValue = value.replace(/\s/g, "").toLowerCase();
    return this.filteredSalesrepOptions.filter(
      (obj) => obj.name.replace(/\s/g, "").toLowerCase().indexOf(filterValue) === 0

    );
  }

  submitAddMoney = () => {
    

    if (this.adminFundsRadioControl.value == 'retailer') {
      let api = {
        minimumThresholdAmount: typeof this.addMoneyForm.get("fallAmount").value == 'string' ? this.addMoneyForm.get("fallAmount").value.replace(/[^a-zA-Z0-9 ]/g, "") : this.addMoneyForm.get("fallAmount").value,
        autoReloadThresholdStatus: this.autoReloadAlertControl.value,
        autoReloadThresholdAmount: typeof this.addMoneyForm.get("autoReloadAmount").value == 'string' ? this.addMoneyForm.get("autoReloadAmount").value.replace(/[^a-zA-Z0-9 ]/g, "") : this.addMoneyForm.get("autoReloadAmount").value,
        mobileForThresholdAlert: this.addMoneyForm.get("mobileNumber").value.replace(/\D+/g, ''),
        mailForThresholdAlert: this.addMoneyForm.get("email").value,
        retailerAccountNum: this.retailerDetailsList.retailerAccounts.retailerAccountNum,
        retailerId: this.retailerDetailsList.retailerAccounts.retailerId,
        lowBalanceThresholdAlertStatus: this.balanceAlertControl.value
        
      }
      
      this.walletService.addRetailerMoney(api).subscribe((res) => {
        if (res['httpcode'] == 200 && res.responseCodes.find(x => x == "TILA_101") || res.responseStatus == 'Success') {
          this.toastService.success('Money added successfully!', 'Success', { timeOut: 2500, progressBar: true, progressAnimation: 'decreasing' })
        }
        this.addMoneyForm.invalid
        this.initiateForm();
        this.creditAvailable = 0
        this.reloadComponent();
      })

    }
    if (this.adminFundsRadioControl.value == 'salesRep') {
      
      // http://52.188.59.223:8081/swagger-ui.html#/SalesReps/addFundsToSalesRepUsingPOST
      let api = {
        //autoReloadAmount
        minimumThresholdAmount: typeof this.addMoneyForm.get("fallAmount").value == 'string' ? this.addMoneyForm.get("fallAmount").value.replace(/[^a-zA-Z0-9 ]/g, "") : this.addMoneyForm.get("fallAmount").value,
        autoReloadThresholdStatus: this.autoReloadAlertControl.value,
        autoReloadThresholdAmount: typeof this.addMoneyForm.get("autoReloadAmount").value == 'string' ? this.addMoneyForm.get("autoReloadAmount").value?.replace(/[^a-zA-Z0-9 ]/g, "") : this.addMoneyForm.get("autoReloadAmount").value,
        mobileForThresholdAlert: this.addMoneyForm.get("mobileNumber")?.value?.replace(/\D+/g, ''),
        mailForThresholdAlert: this.addMoneyForm.get("email").value,
        salesrepAccountNumber: this.retailerDetailsList.accountNumber,
        lowBalanceThresholdAlertStatus: this.balanceAlertControl.value
      }
      this.walletService.addSalesrepMoney(api).subscribe((res) => {
        if (res['httpcode'] == 200 && res.responseCodes.find(x => x == "TILA_101") || res.responseStatus == 'Success') {
          this.toastService.success('Money added successfully!', 'Success', { timeOut: 2500, progressBar: true, progressAnimation: 'decreasing' })
        }
        this.addMoneyForm.invalid
        this.initiateForm();
        this.creditAvailable = 0
        this.reloadComponent();
      })
    }
  }


  onCancel() {
    this.addMoneyForm.reset();
    this.showAutoReload = false;
    this.initiateForm();
    this.creditAvailable = 0;
    this.thresholdAmnt = 0;
    this.showLowbalanceAlert = false;
    this.reloadComponent();
    //this.router.navigateByUrl('features/wallet/add-money');
    //alert("Hello")
  }
  reloadComponent() {
    let currentUrl = this.router.url;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
    }  

}
